(function() {
  'use strict';
  window.Brume = window.Brume || {};

/**
 * Header Navigation Behavior
 * - Show/hide on scroll (Kole-style)
 * - Only show sticky header when scrolling up AFTER passing hero
 * - Mobile menu toggle
 */

function initHeader() {
  const header = document.getElementById('header');
  const nav = document.getElementById('nav');
  const menuToggle = document.getElementById('menuToggle');
  const hero = document.querySelector('.hero');

  if (!header) return;

  // Get hero height to know when we've passed it
  const getHeroBottom = () => {
    if (hero) {
      return hero.offsetTop + hero.offsetHeight;
    }
    return window.innerHeight; // Fallback to viewport height
  };

  // Scroll behavior - hide on scroll down, show on scroll up (only after hero)
  let lastScroll = 0;
  let heroBottom = getHeroBottom();

  // Update hero bottom on resize
  window.addEventListener('resize', () => {
    heroBottom = getHeroBottom();
  });

  const isMobile = () => window.innerWidth <= 768;

  function handleScroll() {
    const currentScroll = window.scrollY;

    // On mobile: hide on scroll down, reveal on scroll up (Kole-style)
    if (isMobile()) {
      // Near the very top — always show, no background
      if (currentScroll <= 50) {
        header.classList.remove('is-hidden');
        header.classList.remove('is-scrolled');
        lastScroll = currentScroll;
        return;
      }

      // Past the top — solid background
      header.classList.add('is-scrolled');

      // Scrolling down past a small threshold hides the header;
      // scrolling up reveals it again immediately.
      if (currentScroll > lastScroll && currentScroll > 100) {
        header.classList.add('is-hidden');
      } else if (currentScroll < lastScroll) {
        header.classList.remove('is-hidden');
      }

      lastScroll = currentScroll;
      return;
    }

    // If no hero exists, always stay in scrolled state
    if (!hero) {
      header.classList.add('is-scrolled');
      if (currentScroll > lastScroll && currentScroll > 100) {
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }
      lastScroll = currentScroll;
      return;
    }

    // While in hero section - keep header visible, no sticky behavior
    if (currentScroll < heroBottom - 100) {
      header.classList.remove('is-hidden');
      header.classList.remove('is-scrolled');
      lastScroll = currentScroll;
      return;
    }

    // Past hero section - enable sticky behavior
    header.classList.add('is-scrolled');

    // Scrolling down - hide header
    if (currentScroll > lastScroll) {
      header.classList.add('is-hidden');
    }
    // Scrolling up - show header (sticky)
    else if (currentScroll < lastScroll) {
      header.classList.remove('is-hidden');
    }

    lastScroll = currentScroll;
  }

  // Throttled scroll handler
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });

  // Initial check
  handleScroll();

  // Mobile menu toggle
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', () => {
      menuToggle.classList.toggle('is-active');
      nav.classList.toggle('is-open');
      var open = nav.classList.contains('is-open');
      // Shared lock (see brume-cart.js) — plain overflow:hidden is ignored by iOS.
      if (window.Brume && Brume.lockScroll) {
        open ? Brume.lockScroll() : Brume.unlockScroll();
      } else {
        document.body.style.overflow = open ? 'hidden' : '';
      }
      document.body.classList.toggle('menu-open', open);
    });

    // Close menu when clicking a link
    nav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', (e) => {
        menuToggle.classList.remove('is-active');
        nav.classList.remove('is-open');
        // Must unlock before navigating: body stays position:fixed otherwise.
        if (window.Brume && Brume.unlockScroll) Brume.unlockScroll();
        else document.body.style.overflow = '';
        document.body.classList.remove('menu-open');

        // Same-page anchors ("Why brume" -> #features on the homepage) need
        // handling explicitly. unlockScroll() ends by restoring the scroll
        // position the menu was opened at, which competes with the browser's
        // fragment jump and usually wins — so the tap appeared to do nothing.
        // Scroll to the section ourselves, offset by the fixed header.
        var href = link.getAttribute('href') || '';
        var hash = href.indexOf('#');
        if (hash === -1) return;
        var id = href.slice(hash + 1);
        var path = href.slice(0, hash);
        if (!id || (path && path !== window.location.pathname)) return;
        var target = document.getElementById(id);
        if (!target) return;

        e.preventDefault();
        requestAnimationFrame(function () {
          var header = document.querySelector('.header');
          // 16px is the header's `top` inset; 12 more keeps the heading clear.
          var offset = (header ? header.offsetHeight : 0) + 28;
          var y = target.getBoundingClientRect().top + window.pageYOffset - offset;

          // Mobile carousels carry dots pinned to the bottom of the section. The
          // section is taller than the viewport, so aligning its top under the
          // header leaves the dots below the fold and the carousel reads as a
          // single static card. Scroll far enough to land them on screen.
          var dots = target.querySelector('.features-dots');
          if (dots && window.getComputedStyle(dots).display !== 'none') {
            var dotsBottom = dots.getBoundingClientRect().bottom + window.pageYOffset;
            var needed = dotsBottom + 12 - window.innerHeight;
            if (needed > y) y = needed;
          }

          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
          try { history.replaceState(null, '', '#' + id); } catch (err) {}
        });
      });
    });
  }
}

  window.Brume.initHeader = initHeader;
})();
